export enum NotificationEndPointEnum {
  NOTIFICATION = "/notification",
  MARK_NOTIFICATION = "/notification/mark",
  MARK_NOTIFICATION_AS_READ = "/notification/mark/all",
}
